export default "__VITE_ASSET__C0jJpGUi__"